{{#with (or envConfigHandle configHandle)}}
function void update_variables({{ type }} {{ identifier }});
  {{ ../parent.type }}.update_variables({{ identifier }});
endfunction
{{/with}}
